/* eslint-disable */
import React from "react";
import { Card, Title, Divider } from "@mantine/core";

export default function DisclosureOfPersonalDataCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Disclosure of Your Personal Data</Title>
      <Divider my="md" />
    </Card>
  );
}
